/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FirstName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function FirstName({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/NewRelation/Add/Content/Details/FirstName",
  isInvalid,
  onChange
  
}) {
let newRelationPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'person.first_name',
})
let newRelationPersonFirstNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'person.first_name',
validate: fromValidate.name,
required: true,
})
let newRelationPersonFirstNameChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'person.first_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="new_relation.person.first_name"
 validate="/Data/validate.js name"
 required={true}
 invalid={!newRelationPersonFirstNameIsValidData}
 value={newRelationPersonFirstNameValueData}
 onChange={newRelationPersonFirstNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="First name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}